// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactionsPopover__container-eaf8fe {
  position: relative;
  padding: 0px;
  box-shadow: var(--box-shadow-12);
  border-radius: 24px;
  border: 1px solid var(--base-20);
  overflow: hidden;
}

.ReactionsPopover__full-view-container-b544dd:before {
  position: absolute;
  content: "";
  top: 0px;
  inset-inline-start: 0px;
  width: 100%;
  height: 19px;
  background: linear-gradient(180deg, var(--base-15) 0%, var(--base-15_00) 100%);
}

.ReactionsPopover__full-view-container-b544dd:after {
  position: absolute;
  content: "";
  bottom: 0px;
  inset-inline-start: 0px;
  width: 100%;
  height: 19px;
  background: linear-gradient(180deg, var(--base-15_00) 0%, var(--base-15) 100%);
}

.ReactionsPopover__content-d5bb43 {
  display: inline-grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 2px;
  padding: 4px;
  box-sizing: border-box;
}

.ReactionsPopover__full-view-container-b544dd .ReactionsPopover__content-d5bb43 {
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 7px;
  max-height: 180px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-inline-start: 8px;
  padding-inline-end: 9px;
  overflow-x: hidden;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ReactionsPopover/ReactionsPopover.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,8EAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,8EAAA;AACF;;AAEA;EACE,oBAAA;EACA,qCAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,qCAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  padding: 0px;\n  box-shadow: var(--box-shadow-12);\n  border-radius: 24px;\n  border: 1px solid var(--base-20);\n  overflow: hidden;\n}\n\n.full-view-container:before {\n  position: absolute;\n  content: '';\n  top: 0px;\n  inset-inline-start: 0px;\n  width: 100%;\n  height: 19px;\n  background: linear-gradient(180deg, var(--base-15) 0%, var(--base-15_00) 100%);\n}\n\n.full-view-container:after {\n  position: absolute;\n  content: '';\n  bottom: 0px;\n  inset-inline-start: 0px;\n  width: 100%;\n  height: 19px;\n  background: linear-gradient(180deg, var(--base-15_00) 0%, var(--base-15) 100%);\n}\n\n.content {\n  display: inline-grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-gap: 2px;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.full-view-container .content {\n  grid-template-columns: repeat(6, 1fr);\n  grid-gap: 7px;\n  max-height: 180px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-inline-start: 8px;\n  padding-inline-end: 9px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReactionsPopover__container-eaf8fe`,
	"full-view-container": `ReactionsPopover__full-view-container-b544dd`,
	"fullViewContainer": `ReactionsPopover__full-view-container-b544dd`,
	"content": `ReactionsPopover__content-d5bb43`
};
module.exports = ___CSS_LOADER_EXPORT___;
